// src/index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './shared/styles/global.scss';
import './i18n'; // Import i18n configuration
import { BrowserRouter as Router } from 'react-router-dom'; // Import Router here

const container = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>
);